import { LanguageTypes } from '@components/LetzChat';
import { ROUTES } from '@utils/getAppRoute';
// This array must not empty be and english should be on the 0th element
export const LANGUAGE_OPTIONS: { value: LanguageTypes; label: string }[] = [
  {
    value: 'en',
    label: 'English',
  },
  // {
  //   value: 'ar',
  //   label: 'عربي',
  // },
  // {
  //   value: 'nl',
  //   label: 'Dutch',
  // },
  {
    value: 'de',
    label: 'German',
  },
  {
    value: 'ru',
    label: 'Russian',
  },
  {
    value: 'hi',
    label: 'Hindi',
  },
  // {
  //   value: 'tr',
  //   label: 'Turkish',
  // },
  // {
  //   value: 'fr',
  //   label: 'French',
  // },
  // {
  //   value: 'ms',
  //   label: 'Malay',
  // },
  // {
  //   value: 'kk',
  //   label: 'Kazakh',
  // },
  // {
  //   value: 'zh-CN',
  //   label: 'Chinese',
  // },
];
export const LANG_KEYS = LANGUAGE_OPTIONS.map((o) => o.value);
export const NAVIGATION_LINKS: {
  name: string;
  href: keyof typeof ROUTES | '';
  iconType: string | null;
}[] = [
  // { name: 'Retail', href: 'RETAIL', iconType: null },
  { name: 'Destination', href: '', iconType: 'downarrow-svg' },
  { name: 'Communities', href: 'COMMUNITIES', iconType: null },
  { name: 'Properties', href: 'UNITS', iconType: null },
  { name: 'Aldar+', href: '', iconType: 'downarrow-svg' },
];
